import type { Limiar, Toxico } from "@vetbolso/contracts";

/** Limiares que valem para a espécie (os de "todas" inclusive). */
export const limiaresDa = (t: Pick<Toxico, "limiares">, especie: string) =>
  (t.limiares || []).filter((l) => l.especie === especie || l.especie === "todas");

export type CalculoTox = {
  /** Dose ingerida por kg, na unidade do limiar. */
  valor: number;
  un: string;
  /** Maior limiar atingido; ausente quando abaixo do menor limiar conferido. */
  atingido?: Limiar;
  gravidade: "abaixo" | "leve" | "grave";
};

/**
 * Dose ingerida por kg comparada aos limiares da espécie.
 * `tipo` escolhe o fator de conversão (mg de metilxantina por g de chocolate, por exemplo).
 */
export function toxCalc(
  t: Toxico,
  especie: string,
  peso: number | null | undefined,
  qtd: number | null | undefined,
  tipo = 0,
): CalculoTox | null {
  if (!t.calc) return null;
  const lim = limiaresDa(t, especie)
    .filter((l) => l.valor != null)
    .sort((a, b) => a.valor! - b.valor!);
  if (!qtd || !peso) return null;
  const fator = t.calc.fatores ? t.calc.fatores[tipo]?.fator : 1;
  if (fator == null) return null;
  const valor = (qtd * fator) / peso;
  const atingido = lim.filter((l) => valor >= l.valor!).pop();
  return {
    valor,
    un: lim[0]?.un || t.calc.un || "",
    atingido,
    gravidade: !atingido ? "abaixo" : atingido.nivel === "leve" ? "leve" : "grave",
  };
}
